"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonGroup = exports.StyledInfoMessage = exports.StyledSelectActionContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.StyledSelectActionContainer = styled_1.default.div `
  display: flex;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  flex-direction: column;
`;
exports.StyledInfoMessage = styled_1.default.p `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  margin: 0;
`;
exports.StyledButtonGroup = styled_1.default.div `
  display: flex;
  flex-direction: ${(props) => (props.isDesktop ? 'row' : 'column')};
  flex-basis: ${(props) => (props.isDesktop ? 'auto' : '100%')};
  gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
//# sourceMappingURL=styles.js.map